module.exports = __webpack_public_path__ + "static/media/tab_2_og.7298b948.png";